// DEPRECATED: Use PriceTag from baby-design
// after product cards / PLPs have been migrated to new folder architecture
import React from 'react'
import classnames from 'classnames'
import css from './PriceTag.styles.scss'

const SALE_THRESHOLD = 0.95 // At least 5% off

export interface PriceTagProps {
  msrp?: number
  minPrice?: number
  maxPrice?: number
  currentPrice?: number
  currentlyInActiveSale?: boolean
  truncateZeroCents?: boolean
}

const PriceTag: React.FC<PriceTagProps> = ({
  msrp,
  minPrice,
  maxPrice,
  currentPrice,
  currentlyInActiveSale,
  truncateZeroCents = false,
}) => {
  const displayPriceRange =
    Boolean(minPrice) && Boolean(maxPrice) && minPrice !== maxPrice

  const currentPriceUnderMsrp =
    typeof currentPrice === 'number' &&
    typeof msrp === 'number' &&
    currentPrice < msrp &&
    currentPrice / msrp <= SALE_THRESHOLD

  const priceRangeUnderMsrp =
    typeof msrp === 'number' &&
    typeof minPrice === 'number' &&
    typeof maxPrice === 'number' &&
    minPrice === maxPrice &&
    maxPrice < msrp

  const onSale =
    currentlyInActiveSale === undefined // TODO - remove this check once cache refreshes
      ? currentPriceUnderMsrp || priceRangeUnderMsrp
      : currentlyInActiveSale

  const formatPriceVisually = (price?: number) => {
    if (typeof price !== 'number') return null

    const [dollars, cents] = price.toFixed(2).split('.')

    const showCents = truncateZeroCents ? parseInt(cents) > 0 : true

    return (
      <div className={css['PriceTag__price']}>
        <span>$</span>
        <div className={css['PriceTag__numerals']}>
          <span className={css['PriceTag__dollars']}>{dollars}</span>
          {showCents && (
            <>
              <span className="visually-hidden">.</span>
              <span className={css['PriceTag__cents']}>{cents}</span>
            </>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className={css.PriceTag}>
      {displayPriceRange ? (
        <div
          className={classnames(
            css['PriceTag__range'],
            onSale && css['PriceTag__range--sale']
          )}
          data-testid="range"
        >
          {formatPriceVisually(minPrice)}
          <span
            className={classnames(
              css['PriceTag__range__separator'],
              onSale && css['PriceTag__range__separator--sale']
            )}
          >
            -
          </span>
          {formatPriceVisually(maxPrice)}
        </div>
      ) : (
        <>
          <div
            className={classnames(
              css['PriceTag__current'],
              onSale && css['PriceTag__current--sale']
            )}
            data-testid="current"
          >
            {formatPriceVisually(currentPrice)}
          </div>
          {currentPriceUnderMsrp && (
            <div className={css['PriceTag__msrp']} data-testid="msrp">
              <span className={css['PriceTag__msrp__strike-through']}></span>
              {formatPriceVisually(msrp)}
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default PriceTag
